const SUPPORTED_PROXY_LOCALES = new Set([
  "de",
  "en",
  "fr",
  "it",
  "nl",
  "es",
  "pl",
  "pt",
  "sv",
  "da",
  "cs",
  "ro",
  "hu",
  "el",
  "fi",
]);

/** @returns {"de" | "en" | "fr" | "it" | "nl" | "es" | "pl" | "pt" | "sv" | "da" | "cs" | "ro" | "hu" | "el" | "fi"} */
export function readProxyLocale() {
  const raw =
    typeof window !== "undefined"
      ? window.Shopify?.locale || document.documentElement.lang || navigator.language
      : "de";
  const normalized = String(raw || "de").toLowerCase().split("-")[0];

  return SUPPORTED_PROXY_LOCALES.has(normalized) ? normalized : "de";
}
